import { Link, useLocation, useHistory } from "react-router-dom";
import { getProjectList, TaskSummary } from "./Service/TaskService";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions";
import { ProjectModalContext } from "./Service/ProjectModalContext";
import { TostMsg } from "../../../App";
import { useSelector } from "react-redux";

export const TaskSidebar = () => {
  const [allProjects, setAllProject] = useState([]);
  const location = useLocation();
  const [projectSummary, setProjectSummary] = useState([]);
  let userPermissions = getRawPermissionsArray();
  const [clientManage, setClientManage] = useState(false);
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(null);
  const [createProject, setCreateProject] = useState(false);
  const [projectSearch, setProjectSearch] = useState(false);
  const toster = useContext(TostMsg);
  const [isDeletedModal, setDeleteModal] = useState(false);
  const [projectData, setProjectData] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [bodyOpen, setBodyOpen] = useState(false);
  const searchBoxRef = useRef(null);
  const colors = ["#EC4119", "#7c3aed", "#0891b2", "#16a34a"];
  const ApplyRecentProjectDatatData = useSelector(
    (state) => state.recentProjects.recentProjectData
  );
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");


  // 1. Context se naya value lo
  const {
    openAddProject,
    openAddNewTask,
    isAddProjectOpen,
    isAddClientOpen,
    selectedProject,
    setSelectedProject,
    registerRefreshCallback,    // NEW
  } = useContext(ProjectModalContext);

  // 2. selectedProject ko ref mein track karo (existing useRef ke saath add karo)
  const selectedProjectRef = useRef(null);

  useEffect(() => {
    selectedProjectRef.current = selectedProject;
  }, [selectedProject]);

  // 3. Yeh refreshCurrentProject function add karo
  const refreshCurrentProject = useCallback(async () => {
    let body = {
      Id: 0,
      StartDate: "",
      EndDate: "",
      ProjectStatusId: "",
      PageNumber: 1,
      PageSize: 1000,
      Search: "",
      ProjectTypeId: "",
      ClientId: "",
      SortBy: "",
      SortOrder: "",
    };
    try {
      let res = await getProjectList(body);
      const projectList = res?.Data?.ProjectList || [];
      setProjectData(projectList);

      // Current selected project ko fresh data se update karo
      const currentSelected = selectedProjectRef.current;
      if (currentSelected?.Id) {
        const updated = projectList.find((p) => p.Id === currentSelected.Id);
        if (updated) {
          setSelectedProject(updated);
        }
      }
    } catch (error) {
      toster.current.error(
        error.response?.Data?.Message || "Something went wrong"
      );
    }
  }, []);

  // 4. Register karo mount pe — existing useEffect ke saath
  useEffect(() => {
    registerRefreshCallback(refreshCurrentProject);
  }, [refreshCurrentProject, registerRefreshCallback]);

  // 5. getProjects function ko replace karo
  async function getProjects() {
    await refreshCurrentProject();
  }

  const getProjectGuid = (project) =>
    project?.GUID ||
    project?.Guid ||
    project?.ProjectGUID ||
    project?.ProjectGuid ||
    project?.EntityGUID ||
    project?.EntityGuid ||
    "";

  const navigateProjectDetail = (projectGuid) => {
    if (!projectGuid) return;
    history.push(`/Project/Detail/${projectGuid}`);
  };

  const getProjectValueName = (value) =>
    typeof value === "object" && value !== null
      ? value?.Name || ""
      : value || "";

  const handleProjectSelect = (proj, closeSearch = true) => {
    console.log(proj, "proj>>>>>>>>>>>>>>>>>")
    setBodyOpen(true);
    setSelectedProject(proj);
    setFilteredProjects([]);
    if (closeSearch) setProjectSearch(false);
    // navigateProjectDetail(getProjectGuid(proj));
  };

  const toggleProjectSearch = () => {
    setProjectSearch((prev) => {
      const next = !prev;
      if (next) {
        setSelectedProject("");
        setFilteredProjects(projects);
      }
      return next;
    });
  };

  const latestProjects = [...projects]
    .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
    .slice(0, 4);

  const searchParams = new URLSearchParams(location.search);
  const currentPath = location.pathname?.replace(/\/+$/, "");
  const isAddTaskActive = currentPath === "/Project/Task/List" && searchParams.get("action") === "addProject";
  const isTaskListActive = currentPath === "/Project/Task/List" && !isAddTaskActive;
  const isAddProjectActive = currentPath === "/Project/List" && searchParams.get("action") === "addProject";
  const isProjectListActive = currentPath === "/Project/List" && !isAddProjectActive;

  useEffect(() => {
    if (Array.isArray(projectData)) {
      setProjects(projectData);
      setFilteredProjects(projectData);
    }
  }, [projectData]);

  useEffect(() => {
    let timer;
    if (ApplyRecentProjectDatatData) {
      timer = setTimeout(() => {
        getTaskSummary();
      }, 1000);
    } else {
      getTaskSummary();
    }
    getProjects();
    permissionList();

    const handleClickOutside = (event) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
        setProjectSearch(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ApplyRecentProjectDatatData]);

  const permissionList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName === "Client.Manage") setClientManage(true);
        if (UserPermission?.PermissionName === "Project.Create") setCreateProject(true);
      });
    }
  };

  useEffect(() => {
    const path = location.pathname;
    if (path === "/Project/Dashboard") setActiveTab("dashboard");
    else if (path === "/Project/Task/List") setActiveTab("myTasks");
    else if (path === "/Project/Tasks/All") setActiveTab("allTasks");
    else if (path === "/Project/List") setActiveTab("projects");
    else if (path === "/Project/Clients") setActiveTab("clients");
    else if (path.startsWith("/Project/Detail/")) setActiveTab("projects");
    else if (path.startsWith("/Project/List/")) setActiveTab("projects");
    else if (path.startsWith("/Project/Task/Detail/")) {
      setActiveTab((prev) =>
        prev === "allTasks" || prev === "myTasks" ? prev : "myTasks"
      );
    }
  }, [location.pathname]);

  async function getTaskSummary() {
    const params = { DateRange: 0 };
    try {
      const response = await TaskSummary(params);
      if (response?.StatusCode === 2000) {
        setProjectSummary(response?.Data?.Summary);
        setAllProject(response?.Data?.RecentProjects);
      }
    } catch (error) {
      toster.current.error(error.response?.Data?.Message || "Something went wrong");
    }
  }

  const toggleSprintBody = () => setBodyOpen(!bodyOpen);

  const filterProjects = (query) => {
    if (!query) {
      setFilteredProjects(projects);
      return;
    }
    const filtered = projects.filter((project) =>
      project?.Name?.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredProjects(filtered);
  };

  async function getProjects() {
    let body = {
      Id: 0,
      StartDate: "",
      EndDate: "",
      ProjectStatusId: "",
      PageNumber: 1,
      PageSize: 1000,
      Search: "",
      ProjectTypeId: "",
      ClientId: "",
      SortBy: "",
      SortOrder: "",
    };
    try {
      let res = await getProjectList(body);
      const projectList = res?.Data?.ProjectList || [];
      setProjectData(projectList);
    } catch (error) {
      toster.current.error(error.response?.Data?.Message || "Something went wrong");
    }
  }

  return (
    <>
      <nav className="tm-drawer" id="tmDrawer">
        <div className="tm-drawer-head">
          <div>
            <div className="tm-drawer-head-title">Workspaces</div>
          </div>
        </div>
        <div className="tm-sidebar-scroll">
          <div className="tm-nav mt-2">
            <Link
              to="/Project/Dashboard"
              className={`tm-item ${activeTab === "dashboard" ? "active" : ""}`}
              onClick={() => setActiveTab("dashboard")}
            >
              <i className="fa-solid fa-gauge-high"></i>
              <span>Dashboard</span>
            </Link>

            <Link
              to="/Project/Task/List"
              className={`tm-item ${activeTab === "myTasks" ? "active" : ""}`}
              onClick={() => setActiveTab("myTasks")}
            >
              <i className="fa-solid fa-circle-user"></i>
              <span>My Tasks</span>
              <span className="tm-badge">{projectSummary?.TotalMyTasks || 0}</span>
            </Link>

            <Link
              to="/Project/Tasks/All"
              className={`tm-item ${activeTab === "allTasks" ? "active" : ""}`}
              onClick={() => setActiveTab("allTasks")}
            >
              <i className="fa-solid fa-list-check"></i>
              <span>All Tasks</span>
              <span className="tm-badge">{projectSummary?.ActiveTasks || 0}</span>
            </Link>

            <Link
              to="/Project/List"
              className={`tm-item ${activeTab === "projects" ? "active" : ""}`}
              onClick={() => setActiveTab("projects")}
            >
              <i className="fa-solid fa-folder-open"></i>
              <span>Projects</span>
              <div className="ml-auto">
                 
                {createProject && (
                  <span className="add-projecticon" title="Add Project">
                    <i onClick={openAddProject} className="fa-solid fa-plus"></i>
                  </span>
                )}
                <span className="tm-badge" style={{ marginLeft: "1px" }}>
                  {projectSummary?.TotalProjects || 0}
                </span>
              </div>
            </Link>

            {clientManage && (
              <Link
                to="/Project/Clients"
                className={`tm-item ${activeTab === "clients" ? "active" : ""}`}
                onClick={() => setActiveTab("clients")}
              >
                <i className="fa-solid fa-users"></i>
                <span>Clients</span>
                <span className="tm-badge">{projectSummary?.TotalClients || 0}</span>
              </Link>
            )}
          </div>

          <div className="tm-divider"></div>

          <div className="">
            <div className="sprint-section">
              <div className="tm-sec">Sprints</div>

              {projectSearch && (
                <div className="proj-search-box" style={{ display: "block" }} ref={searchBoxRef}>
                  <input
                    className="proj-search-input"
                    id="projSearchInput"
                    placeholder="Search projects…"
                    value={getProjectValueName(selectedProject)}
                    onChange={(e) => {
                      const val = e.target.value;
                      setSelectedProject(val);
                      filterProjects(val);
                    }}
                    autoComplete="off"
                  />
                  {filteredProjects?.length > 0 && selectedProject && (
                    <div className="proj-search-results">
                      <span className="psr-dot text-danger"></span>
                      {filteredProjects.map((proj) => (
                        <div
                          key={proj.Id}
                          className="recent-item psr-item"
                          onClick={() => handleProjectSelect(proj)}
                        >
                          {proj.Name || "n/a"}
                        </div>
                      ))}
                    </div>
                  )}

                  {latestProjects?.length > 0 && !selectedProject && (
                    latestProjects.map((proj, index) => (
                      <div
                        key={proj.Id || index}
                        className={`psr-item ${selectedProject?.Id === proj.Id ? "sel" : ""}`}
                        onClick={() => handleProjectSelect(proj)}
                      >
                        <span
                          className="psr-dot"
                          style={{ background: proj.color || colors[index % colors.length] }}
                        ></span>
                        <span style={{ flex: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          {proj?.Name || "n/a"}
                        </span>
                        {selectedProject?.Id === proj.Id && (
                          <i className="fa-solid fa-check" style={{ fontSize: "10px", color: "#EC4119", marginLeft: "4px" }} />
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}

              <div className={`proj-header ${bodyOpen ? "expanded" : ""}`} id="projHeader">
                <button className="proj-toggle-btn" onClick={toggleSprintBody}>
                  <span className="rp-dot" id="selDot"></span>
                  <span className="proj-name-text" id="selLabel">
                    {getProjectValueName(selectedProject) || "Select Project"}
                  </span>
                  <i className={`fa-solid fa-chevron-right proj-chevron ${bodyOpen ? "open" : ""}`} id="selChevron"></i>
                </button>
                <button className="proj-search-btn" id="projSearchBtn" onClick={toggleProjectSearch} title="Search project">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>

              <div className={`sprint-body ${bodyOpen ? "open" : ""}`} id="sprintBody">

                {(() => {
                  const PLANNING_STATUS_ID = 1;
                  const ACTIVE_STATUS_ID = 2;
                  const PAUSED_STATUS_ID = 3;

                  const rawActive = selectedProject?.ProjectSprints?.ActiveSprint;
                  const rawPlanning = selectedProject?.ProjectSprints?.PlanningSprint || [];
                  const allSprints = [...(rawActive ? [rawActive] : []), ...rawPlanning];

                  const trueActive = allSprints.find(
                    s => s.SprintStatusId === ACTIVE_STATUS_ID || s.SprintStatusId === PAUSED_STATUS_ID
                  );
                  const truePlanning = allSprints.filter(s => s.SprintStatusId === PLANNING_STATUS_ID);

                  return (
                    <>
                      {trueActive && (
                        <Link to={{ pathname: "/Project/Sprint", state: { view: "active" } }}>
                          <div className="sp-row sp-current">
                            <div className="sp-icon"><i className="fa-solid fa-bolt"></i></div>
                            <div className="sp-label">
                              <div className="sp-name">
                                {trueActive.SprintName}
                              </div>
                              <div className="sp-sub">
                                {trueActive.SprintStatusId === PAUSED_STATUS_ID ? "Paused" : "Current"} · ends{" "}
                                {new Date(trueActive.PlannedEndDate).toLocaleDateString("en-GB", {
                                  day: "numeric", month: "short", year: "numeric"
                                })}
                              </div>
                            </div>
                            <span className="sp-count">{trueActive.TotalTasksInSprint}</span>
                          </div>
                        </Link>
                      )}

                      {truePlanning.map((data, index) => (
                        <div
                          key={data.Id || index}
                          className="sp-row sp-upcoming"
                          onClick={() => {
                            history.push({
                              pathname: "/Project/Sprint",
                              state: { view: "planning", sprint: data }
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="sp-icon"><i className="fa-regular fa-clock"></i></div>
                          <div className="sp-label">
                            <div className="sp-name">{data.SprintName}</div>
                            <div className="sp-sub">Planning</div>
                          </div>
                          <span className="sp-count">{data.TotalTasksInSprint}</span>
                        </div>
                      ))}
                    </>
                  );
                })()}
                {/* {selectedProject?.ProjectSprints?.ActiveSprint && (
                  <Link to={{ pathname: "/Project/Sprint", state: { view: "active" } }}>
                    <div className="sp-row sp-current">
                      <div className="sp-icon"><i className="fa-solid fa-bolt"></i></div>
                      <div className="sp-label">
                        <div className="sp-name">
                          {selectedProject.ProjectSprints.ActiveSprint.SprintName} 
                        </div>
                        <div className="sp-sub">
                          Current · ends {new Date(selectedProject.ProjectSprints.ActiveSprint.PlannedEndDate).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                        </div>
                      </div>
                      <span className="sp-count">{selectedProject.TotalTasksInSprint}</span>
                    </div>
                  </Link>
                )}

                {selectedProject?.ProjectSprints?.PlanningSprint?.length > 0 && (
                  <Link to={{ pathname: "/Project/Sprint", state: { view: "planning" } }}>
                    <div className="sp-row sp-upcoming">
                      <div className="sp-icon"><i className="fa-regular fa-clock"></i></div>
                      <div className="sp-label">
                        <div className="sp-name">
                          {selectedProject.ProjectSprints.PlanningSprint[0].SprintName} 
                        </div>
                        <div className="sp-sub">Planning</div>
                      </div>
                      <span className="sp-count">{selectedProject.ProjectSprints.PlanningSprint[0].TotalTasksInSprint}</span>
                    </div>
                  </Link>
                )} */}

                {selectedProject?.ProjectSprints?.CompletedSprints?.length > 0 && (
                  <Link to={{ pathname: "/Project/PastSprints", state: { view: "completed" } }}>
                    <div className="sp-row sp-past">
                      <div className="sp-icon"><i className="fa-solid fa-box-archive"></i></div>
                      <div className="sp-label">
                        <div className="sp-name">Past Sprints</div>
                        <div className="sp-sub">{selectedProject.ProjectSprints.CompletedSprints.length} completed</div>
                      </div>
                      <span className="sp-count">{selectedProject.ProjectSprints.CompletedSprints.length}</span>
                    </div>
                  </Link>
                )}

                {selectedProject && (
                  <Link to={`/Project/Backlog/${selectedProject.GUID}`}>
                    <div className="sp-row sp-backlog">
                      <div className="sp-icon"><i className="fa-solid fa-layer-group"></i></div>
                      <div className="sp-label">
                        <div className="sp-name">Backlog</div>
                        <div className="sp-sub">Not in any sprint</div>
                      </div>
                      {/* <span className="sp-count">{selectedProject.TaskCount}</span> */}
                    </div>
                  </Link>
                )}
                {(createProject || (userDetails?.EmpId == selectedProject?.ManagerId)) && (
                  <div
                    className="create-sp-btn"
                    onClick={() =>
                      selectedProject?.ProjectSprints?.CanCreateNewSprint
                        ? history.push({ pathname: "/Project/Sprints", state: { selectedProject } })
                        : setDeleteModal(true)
                    }
                  >
                    <div className="cs-icon"><i className="fa-solid fa-plus"></i></div>
                    <span>Create Sprint</span>
                  </div>
                )}

              </div>
            </div>

            <div className="tm-divider"></div>
            <div className="tm-sec">Recent Projects</div>
            <div className="tm-proj-list">
              {allProjects?.map((p) => {
                const projectGuid = getProjectGuid(p);
                return (
                  <div className="tm-proj-item" key={p.EntityId}>
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => navigateProjectDetail(projectGuid)}
                      onKeyPress={(e) => e.key === "Enter" && navigateProjectDetail(projectGuid)}
                      className="tm-proj-action"
                      title="Project Details"
                    >
                      <div className="tm-proj-info">
                        <span className="tm-proj-dot" style={{ background: "#3b82f6" }}></span>
                        <span className="tm-proj-name">
                          {p?.EntityName?.length > 20 ? `${p.EntityName.slice(0, 20)}...` : p?.EntityName || ""}
                        </span>
                      </div>
                    </div>
                    <div className="tm-proj-actions">
                      <Link to={`/Project/Detail/${projectGuid}`} className="tm-proj-action" title="Project Details">
                        <i className="fa-solid fa-info-circle"></i>
                      </Link>
                      <Link to={`/Project/Tasks/${projectGuid}`} className="tm-proj-action" title="View Tasks">
                        <i className="fa-solid fa-tasks"></i>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <button
          type="button"
          className={`tm-item tm-itembtn set-position ${activeTab === "addTask" ? "active" : ""}`}
          onClick={() => { openAddNewTask(); setActiveTab("addTask"); }}
        >
          <i className="fa-solid fa-plus"></i>
          <span>Add New Task</span>
        </button>
      </nav>

      {isDeletedModal && (
        <div className="modal show" id="delete-task-confirm" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-body pt-3">
                <div className="d-flex align-items-start gap-2">
                  <div className="og-modal-icon-wrap">
                    <i className="fa-solid fa-triangle-exclamation" style={{ color: "#d97706" }}></i>
                  </div>
                  <div className="og-modal-content">
                    <h4>Sprint limit reached</h4>
                    <div>
                      A project can have a maximum of 2 active sprints — one In Progress and one in Planning or two in Planning. You have reached this limit.

                      To create a new sprint, please complete an existing sprint first or delete any Planning sprint.
                      {/* <h6>Active sprints:</h6>
                      <ul>
                        <li>"Sprint 3" (In Progress)</li>
                        <li>"Sprint 4" (Planning)</li>
                      </ul>
                      <h6>To create a new sprint:</h6>
                      <ul>
                        <li>Complete or stop the current sprint, or</li>
                        <li>Delete the Planning sprint.</li>
                      </ul> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer ms-auto">
                {/* <button type="button" className="cancelbtn-click" onClick={() => setDeleteModal(false)}>Cancel</button> */}
                <button type="button" onClick={() => setDeleteModal(false)} className="deletebtn-click">Got it</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TaskSidebar;